import { BalanceCheckerItem, BalanceCheckerItemMaxSpan, BalanceCheckerWrapper } from './styled'

import React from 'react'

/**
 * allows user to select max amount of tokens to buy
 * shows the users balance
 *
 * States:
 * Loading  - when waiting for input coin details to load, ln 18
 * Ready    - when input coin details are loaded
 */
const BalanceChecker: React.FC = () => {
  return (
    <BalanceCheckerWrapper>
      <BalanceCheckerItem>
        <BalanceCheckerItemMaxSpan>Max</BalanceCheckerItemMaxSpan>
      </BalanceCheckerItem>
      <BalanceCheckerItem>|</BalanceCheckerItem>
      <BalanceCheckerItem>{`Balance: 100.00 ETH`}</BalanceCheckerItem>
    </BalanceCheckerWrapper>
  )
}

export default BalanceChecker
